var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse',{attrs:{"collapsable":false}},[_c('ticket-provider',{attrs:{"ticket-id":_vm.ticketId}},[_c('div',[_c('ticket-header',{staticClass:"has-margin-bottom-100"}),_vm._v(" "),_c('ticket-feed')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }